import React from 'react';

export const Recommendations = () => (
  <svg
    width={'35'}
    height={'43'}
    viewBox="0 0 35 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4464 14.1656L20.2449 19.3372L26.0947 20.3652L21.9753 24.5903L22.7908 30.3964L17.4464 27.8372L12.1008 30.3964L12.9163 24.5903L8.79688 20.3652L14.6466 19.3372L17.4464 14.1656Z"
      fill="#2ED3B7"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.3825 11.0446V39.7559C33.3787 40.153 33.2172 40.5329 32.9326 40.8137C32.648 41.0945 32.263 41.2539 31.8605 41.2576H3.0308C2.62791 41.2551 2.24224 41.0961 1.95735 40.815C1.67246 40.5339 1.5113 40.1534 1.50879 39.7559V2.7621C1.50974 2.3641 1.6704 1.98268 1.95563 1.70126C2.24086 1.41983 2.62743 1.26131 3.0308 1.26038H23.4637"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.3825 11.0442H24.9857C24.5823 11.0433 24.1958 10.8847 23.9105 10.6033C23.6253 10.3219 23.4646 9.94047 23.4637 9.54248V1.25757L33.3825 11.0442V11.0442Z"
      stroke="#297FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
